import cx from 'classnames';
import { Location } from 'history';
import { AdSlot } from 'mk2/containers/AdSlot/AdSlot';
import { BrandingProps } from 'mk2/pages/Page';
import React, { useEffect, useRef, useState } from 'react';
import styles from './AdSlotBranding.mscss';

export const PREFIX_AD_SLOT_BRANDING = 'mk-branding';

interface OwnProps extends BrandingProps {
    location: Location;
    isMobile: boolean;
}

type Props = OwnProps;

export const AdSlotBranding: React.FC<Props> = ({
    zone, targeting, location, isMobile,
}) => {
    return (
        <React.Fragment>
            <div
                className={cx(!isMobile && styles.AdSlotBranding__desktopWrap)}
            >
                <AdSlot
                    className={isMobile ? styles.AdSlotBranding__mobile : styles.AdSlotBranding__desktop}
                    zone={isMobile ? `${zone} (Mobile)` : `${zone} (Desktop)`}
                    location={location}
                    targeting={targeting}
                    prefix={PREFIX_AD_SLOT_BRANDING}
                    marginBottomWithAd={isMobile ? 3 : undefined}
                    marginTopWithAd={isMobile ? 3 : undefined}
                />
            </div>
        </React.Fragment>
    );
};
